// CategoryContext.js
import React, { createContext, useContext, useState } from 'react';

// Create context
const CategoryContext = createContext();

// Context provider component
export const CategoryProvider = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState('');

  return (
    <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};

// Hook to access category state in components
export const useCategory = () => useContext(CategoryContext);
